import { openPopupById } from '../../../desktop/common/popup';
import { openPopup } from '../../../mobile/common/popup';
import { textareaInitElement } from '../../mtui/textarea';

window.camp_questions_current_page = 1;


document.addEventListener('client_is_checked', () => {
  if (window.user_is_checked) {
    if (window.client_present) {
      $('.camp_questions_authorized').show();
    } else {
      $('.camp_questions_authorized').hide();
    }
  }
  if (window.tabs_slider) window.tabs_slider.updateSliderHeight();
});

document.addEventListener('user_is_checked', () => {
  if (window.client_is_checked) {
    if (window.user_present) {
      $('.camp_questions_authorized').show();
    } else {
      $('.camp_questions_authorized').hide();
    }
  }
  if (window.tabs_slider) window.tabs_slider.updateSliderHeight();
});

$(function () {
  const initEvents = function () {
    $('.camp_questions_open_form_btn')
      .off('click')
      .click(function () {
        $('.camp_questions_open_form_btn').hide();
        if (window.user_present || window.client_present) {
          $('.camp_question_new_form').show();
        } else {
          $('.camp_questions_only_authorized_banner').show();
        }
        if (window.tabs_slider) window.tabs_slider.updateSliderHeight();
      });

    $('.camp_questions_only_authorized_banner__close')
      .off('click')
      .click(function () {
        $('.camp_questions_only_authorized_banner').hide();
        $('.camp_questions_open_form_btn').show();
      });

    $('.camp_questions_new_form__close')
      .off('click')
      .click(function () {
        $('.camp_question_new_form').hide();
        $('.camp_questions_open_form_btn').show();
      });

    $('.camp_questions_register')
      .off('click')
      .click(function () {
        if (window.isMobileDevice) {
          openPopup('auth-popup');
        } else {
          openPopupById('auth-popup');
        }
        $(".popup-tabs__tab[data-target='auth-register-form']").click();
      });

    $('.camp_questions_login')
      .off('click')
      .click(function () {
        if (window.isMobileDevice) {
          openPopup('auth-popup');
        } else {
          openPopupById('auth-popup');
        }
        $(".popup-tabs__tab[data-target='auth-login-form']").click();
      });

    $('.camp_questions_answer__reply_btn')
      .off('click')
      .click(function () {
        const $wrapper = $(this).parents(`.camp_questions_answer`);
        console.log($wrapper);
        let $form;
        if ($wrapper.find('.camp_questions_reply_form').length > 0) {
          $form = $wrapper.find('.camp_questions_reply_form');
          $form.show();
        } else {
          $form = $('#camp_questions_reply_form_template').clone().show();
          $wrapper.find('.camp_questions_answer__body').append($form);
          textareaInitElement($form.find('.mtui-textarea__input'));
        }
        const $btn = $(this);
        $btn.hide();

        $form
          .find('.camp_questions_reply_form__close')
          .off('click')
          .click(function () {
            $form.hide();
            $btn.show();
          });
        $form
          .find('.camp_questions_reply_form_submit')
          .off('click')
          .click(() => handleSendReply($form));
        if (window.tabs_slider) window.tabs_slider.updateSliderHeight();
      });

    $('.camp_questions_topic__reply_btn')
      .off('click')
      .click(function () {
        const question_id = $(this).data('question_id');
        const $wrapper = $(this).parents(`.camp_questions_topic[data-question_id='${question_id}']`);
        let $form;
        if ($wrapper.find('.camp_questions_reply_form').length > 0) {
          $form = $wrapper.find('.camp_questions_reply_form');
          $form.show();
        } else {
          $form = $('#camp_questions_reply_form_template').clone().show();
          $wrapper.find('.camp_questions_topic__answers').before($form);
          textareaInitElement($form.find('.mtui-textarea__input'));
        }
        const $btn = $(this);
        $btn.hide();

        $form
          .find('.camp_questions_reply_form__close')
          .off('click')
          .click(function () {
            $form.hide();
            $btn.show();
          });
        $form
          .find('.camp_questions_reply_form_submit')
          .off('click')
          .click(() => handleSendReply($form));
        if (window.tabs_slider) window.tabs_slider.updateSliderHeight();
      });

    $('.camp_questions_form_submit')
      .off('click')
      .click(function () {
        const $wrapper = $(this).parents('.camp_question_new_form');
        const body = $wrapper.find('.camp_question_new_form__textarea').val();
        if (body.trim().length === 0) {
          $wrapper.find('.camp_question_new_form__textarea').addClass('input-error');
          return;
        }
        $wrapper.find('.camp_question_new_form__textarea').removeClass('input-error');
        const camp_id = $('.camp_questions_form_submit').data('camp_id');
        $.post(`/camps/${camp_id}/create_question_frontend`, {
          body: body,
        }).then(() => {
          $wrapper.find('.camp_question_new_form__textarea').val("");
          $('.camp_question_new_form').hide();
          $('.camp_questions_form_success').show();
          if (window.tabs_slider) window.tabs_slider.updateSliderHeight();
        });
      });

    $('.camp_questions_success__close')
      .off('click')
      .click(function () {
        $(this).parent().hide();
        $('.camp_questions_open_form_btn').show();
        if (window.tabs_slider) window.tabs_slider.updateSliderHeight();
      });
  };

  const handleSendReply = ($form) => {
    const body = $form.find('#camp_questions_form__textarea').val();
    const camp_id = $form.data('camp_id');
    const is_answer = $form.parents('.camp_questions_answer').length > 0;
    const $parentWrapper = is_answer ? $form.parents('.camp_questions_answer') : $form.parents('.camp_questions_topic');

    const parent_id = $parentWrapper.data('question_id');

    $.post(`/camps/${camp_id}/create_question_frontend`, {
      body: body,
      parent_id: parent_id,
    }).then(() => {
      $form.find('#camp_questions_form__textarea').val("");
      $form.replaceWith($('.camp_questions_form_reply_success_template').eq(0).clone().show().css('display', 'flex'));
      $('.camp_questions_success__close').click(function () {
        $(this).parent().hide();
      });
      if (window.tabs_slider) window.tabs_slider.updateSliderHeight();
    });
  };

  initEvents();

  $('#camp_questions_more_btn').click(function () {
    const camp_id = $(this).data('camp_id');
    $.get(`/camps/${camp_id}/questions_load_more?page=${window.camp_questions_current_page + 1}`).then((res) => {
      $('.camp_questions').append(res);
      const total_pages = $('.camp_questions .camp_questions_topic').last().data('total_pages');
      if (total_pages <= window.camp_questions_current_page) {
        $('#camp_questions_more_btn').hide();
      }
      initEvents();
      if (window.tabs_slider) window.tabs_slider.updateSliderHeight();
    });
    window.camp_questions_current_page += 1;
  });
});
